/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const VIDEO_ANALYTIC_STATUS_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:video analytic status.pending'); } },
  { value: 1, get label() { return i18n.t('constants:video analytic status.in_progress'); } },
  { value: 2, get label() { return i18n.t('constants:video analytic status.done'); } },
  { value: 3, get label() { return i18n.t('constants:video analytic status.restart'); } },
  { value: 4, get label() { return i18n.t('constants:video analytic status.failure'); } },
  { value: 5, get label() { return i18n.t('constants:video analytic status.stop'); } },
  { value: 6, get label() { return i18n.t('constants:video analytic status.unknown'); } },
  { value: 8, get label() { return i18n.t('constants:video analytic status.paused'); } },
]);

export const VIDEO_ANALYTIC_TYPES_OPTIONS_BASE = optionsProxy.create([
  { value: 'handsup', get label() { return i18n.t('constants:video analytic types.handsup'); } },
  { value: 'lying', get label() { return i18n.t('constants:video analytic types.lying'); } },
  { value: 'bag', get label() { return i18n.t('constants:video analytic types.bag'); } },
  { value: 'weapon', get label() { return i18n.t('constants:video analytic types.weapon'); } },
  { value: 'fire', get label() { return i18n.t('constants:video analytic types.fire'); } },
  { value: 'fight', get label() { return i18n.t('constants:video analytic types.fight'); } },
  { value: 'crowd', get label() { return i18n.t('constants:video analytic types.crowd'); } },
  { value: 'fall', get label() { return i18n.t('constants:video analytic types.fall'); } },
]);

export const VIDEO_ANALYTIC_TYPES_OPTIONS = optionsProxy.create([
  ...VIDEO_ANALYTIC_TYPES_OPTIONS_BASE.raw,
  { value: 'facecover', get label() { return i18n.t('constants:video analytic types.facecover'); } },
]);

export const VIDEO_ANALYTIC_TYPES_OPTIONS_V2 = optionsProxy.create([
  ...VIDEO_ANALYTIC_TYPES_OPTIONS_BASE.raw,
  { value: 'facecover', get label() { return i18n.t('constants:video analytic types.facecoverV2'); } },
]);

export const FIRE_TYPE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:fire types.0'); } },
  { value: 1, get label() { return i18n.t('constants:fire types.1'); } },
  { value: 2, get label() { return i18n.t('constants:fire types.2'); } },
]);

export const ROLE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:пользователь'); } },
  { value: 2, get label() { return i18n.t('constants:администратор'); } },
]);

export const GENDER_OPTIONS_STRICT = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:женский'); } },
  { value: 1, get label() { return i18n.t('constants:мужской'); } },
]);

export const GENDER_OPTIONS = optionsProxy.create([
  ...GENDER_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
]);

export const EVENT_OPTIONS = optionsProxy.create([
  { value: 'faces', get label() { return i18n.t('constants:лиц'); } },
  { value: 'events', get label() { return i18n.t('constants:событий'); } },
]);

export const OBJECT_TYPES_OPTIONS = optionsProxy.create([
  { value: 'faces', get label() { return i18n.t('constants:лица'); } },
  { value: 'events', get label() { return i18n.t('constants:события'); } },
]);

export const ETHNIC_OPTIONS = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:афроамериканская'); }, description: 'african_american' },
  { value: 2, get label() { return i18n.t('constants:индийская'); }, description: 'indian' },
  { value: 3, get label() { return i18n.t('constants:азиатская'); }, description: 'asian' },
  { value: 4, get label() { return i18n.t('constants:европеоидная'); }, description: 'caucasian' },
  { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
]);

export const EMOTION_OPTIONS_STRICT = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:гнев'); } },
  { value: 2, get label() { return i18n.t('constants:отвращение'); } },
  { value: 3, get label() { return i18n.t('constants:страх'); } },
  { value: 4, get label() { return i18n.t('constants:счастье'); } },
  { value: 5, get label() { return i18n.t('constants:нейтральность'); } },
  { value: 6, get label() { return i18n.t('constants:грусть'); } },
  { value: 7, get label() { return i18n.t('constants:удивление'); } },
]);

export const EMOTION_OPTIONS = optionsProxy.create([
  ...EMOTION_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
]);

export const MASK_OPTIONS_STRICT = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:mask_states.missing'); } },
  { value: 2, get label() { return i18n.t('constants:mask_states.medical_mask'); } },
  { value: 3, get label() { return i18n.t('constants:mask_states.occluded'); } },
]);

export const MASK_OPTIONS = optionsProxy.create([
  ...MASK_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:оценка не проводилась'); } },
]);

export const TYPE_OPTIONS = [
  { value: 'image_search', get label() { return i18n.t('constants:поиск по изображению'); } },
  { value: 'file_export', get label() { return i18n.t('constants:экспорт в файл'); } },
  { value: 'unknown', get label() { return i18n.t('constants:неизвестный'); } },
];

export const STATUS_OPTIONS = [
  { value: 0, get label() { return i18n.t('constants:в ожидании'); } },
  { value: 1, get label() { return i18n.t('constants:запущено'); } },
  { value: 2, get label() { return i18n.t('constants:готово'); } },
  { value: 3, get label() { return i18n.t('constants:прервано'); } },
  { value: 4, get label() { return i18n.t('constants:отменено'); } },
];
export const TIME_TYPE_OPTIONS = optionsProxy.create([
  { value: 'sec', get label() { return i18n.t('constants:секунды'); } },
  { value: 'frames', get label() { return i18n.t('constants:кадры'); } },
]);

export const CAMERA_PROTOCOL_OPTIONS = optionsProxy.create([
  { value: 'tcp', get label() { return i18n.t('constants:tcp'); } },
  { value: 'udp', get label() { return i18n.t('constants:udp'); } },
]);

export const CAMERA_ROTATION_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return 0; } },
  { value: 90, get label() { return 90; } },
  { value: 180, get label() { return 180; } },
  { value: 270, get label() { return 270; } },
]);

export const LIVENESS_MODE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:первые n кадров'); } },
  { value: 1, get label() { return i18n.t('constants:последние n кадров перед отправкой лучшего кадра'); } },
  { value: 2, get label() { return i18n.t('constants:все кадры трека'); } },
]);

export const CAMERA_STATUS_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:stopped'); } },
  { value: 1, get label() { return i18n.t('constants:active'); } },
  { value: 2, get label() { return i18n.t('constants:connecting'); } },
  { value: 3, get label() { return i18n.t('constants:failed'); } },
]);

export const TASKS_TYPE_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:неизвестный'); } },
  { value: 1, get label() { return i18n.t('constants:компоновка'); } },
  { value: 2, get label() { return i18n.t('constants:кластеризация'); } },
  { value: 3, get label() { return i18n.t('constants:отчет'); } },
  { value: 4, get label() { return i18n.t('constants:сборка мусора'); } },
  { value: 5, get label() { return i18n.t('constants:повторное извлечение'); } },
  { value: 6, get label() { return i18n.t('constants:кросс-матчинг'); } },
  { value: 7, get label() { return i18n.t('constants:расчет roc-кривой'); } },
  { value: 8, get label() { return i18n.t('constants:экспорт'); } },
  { value: 9, get label() { return i18n.t('constants:пакетная обработка'); } },
]);

export const TASKS_STATUS_OPTIONS = [
  { value: 0, get label() { return i18n.t('constants:в ожидании'); } },
  { value: 1, get label() { return i18n.t('constants:в процессе'); } },
  { value: 2, get label() { return i18n.t('constants:отменена'); } },
  { value: 3, get label() { return i18n.t('constants:ошибка'); } },
  { value: 4, get label() { return i18n.t('constants:сбор результатов'); } },
  { value: 5, get label() { return i18n.t('constants:готово'); } },
];

export const DESCRIPTOR_TYPE_OPTIONS = optionsProxy.create([
  { value: 'face', get label() { return i18n.t('constants:лица'); } },
  { value: 'body', get label() { return i18n.t('constants:тела'); } },
]);

export const MULTIFACE_POLICY_OPTIONS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:отбраковывать'); } },
  { value: 1, get label() { return i18n.t('constants:не отбраковывать'); } },
  { value: 2, get label() { return i18n.t('constants:выбирать только одно лицо наилучшего качества'); } },
]);

export const AGE_OPTIONS = optionsProxy.create([
  { value: [0, 18], get label() { return i18n.t('constants:младше 18'); } },
  { value: [18, 45], get label() { return i18n.t('constants:от 18 до 44'); } },
  { value: [45, 61], get label() { return i18n.t('constants:от 45 до 60'); } },
  { value: [61, 100], get label() { return i18n.t('constants:старше 60'); } },
], {
  get(target, prop) {
    if (prop === 'raw') return target;

    if (prop.includes('_')) {
      let [gte, lt] = prop.split('_');
      gte = parseFloat(gte);
      if (Number.isNaN(gte)) gte = undefined;
      lt = parseFloat(lt);
      if (Number.isNaN(lt)) lt = undefined;

      if (gte === undefined && lt === undefined) return null;

      const result = target.find(({ value }) => (
        gte === value[0] && lt === value[1]
      ));

      // eslint-disable-next-line @stylistic/max-statements-per-line
      return result ?? { value: [gte, lt], get label() { return i18n.t('Иное'); } };
    }
    const numberedProp = parseFloat(prop);
    if (Number.isNaN(numberedProp)) return null;

    const result = target.find(({ value: [gte, lt] }) => (
      numberedProp >= gte && numberedProp < lt
    ));

    return result ?? null;
  },
});

export const TEMPERATURE_OPTIONS = optionsProxy.create([
  { value: 't#normal', get label() { return i18n.t('constants:температура.нормальная', { context: 'сокращённое' }); } },
  { value: 't#high', get label() { return i18n.t('constants:температура.повышенная', { context: 'сокращённое' }); } },
  { value: 't#abnormal', get label() { return i18n.t('constants:температура.аномальная', { context: 'сокращённое' }); } },
]);

export const TEMPERATURE_BY_GROUP_OPTIONS = optionsProxy.create([{
  get label() { return i18n.t('температура'); },
  options: [
    { value: 't#normal', get label() { return i18n.t('constants:температура.нормальная', { context: 'сокращённое' }); } },
    { value: 't#high', get label() { return i18n.t('constants:температура.повышенная', { context: 'сокращённое' }); } },
    { value: 't#abnormal', get label() { return i18n.t('constants:температура.аномальная', { context: 'сокращённое' }); } },
  ],
}]);

export const TEMPERATURE_TAG_OPTIONS = optionsProxy.create([
  { value: 't#normal', get label() { return i18n.t('constants:температура.нормальная'); } },
  { value: 't#high', get label() { return i18n.t('constants:температура.повышенная'); } },
  { value: 't#abnormal', get label() { return i18n.t('constants:температура.аномальная'); } },
]);

export const EYE_STATUS_OPTIONS = optionsProxy.create([
  { value: 'open', get label() { return i18n.t('constants:открыт'); } },
  { value: 'closed', get label() { return i18n.t('constants:закрыт'); } },
  { value: 'occluded', get label() { return i18n.t('constants:перекрытие'); } },
]);

export const MOUTH_STATUS_OPTIONS = optionsProxy.create([
  { value: 'opened', get label() { return i18n.t('constants:открыт'); } },
  { value: 'smile', get label() { return i18n.t('constants:улыбка'); } },
  { value: 'occluded', get label() { return i18n.t('constants:перекрытие'); } },
]);

export const DEEPFAKE_STATE_OPTIONS_STRICT = optionsProxy.create([
  { value: 0, get label() { return i18n.t('constants:deepfake.state.fake'); } },
  { value: 1, get label() { return i18n.t('constants:deepfake.state.real'); } },
]);
export const DEEPFAKE_STATE_OPTIONS = optionsProxy.create([
  ...DEEPFAKE_STATE_OPTIONS_STRICT.raw,
  { value: 'null', get label() { return i18n.t('constants:deepfake.state.null'); } },
]);

export const FACE_OCCLUSION_STATE_OPTIONS_STRICT = optionsProxy.create([
  { value: 'face', get label() { return i18n.t('constants:face_occlusion_state.face'); } },
  { value: 'forehead', get label() { return i18n.t('constants:face_occlusion_state.forehead'); } },
  { value: 'eye', get label() { return i18n.t('constants:face_occlusion_state.eye'); } },
  { value: 'nose', get label() { return i18n.t('constants:face_occlusion_state.nose'); } },
  { value: 'mouth', get label() { return i18n.t('constants:face_occlusion_state.mouth'); } },
  { value: 'lower_face', get label() { return i18n.t('constants:face_occlusion_state.lower_face'); } },
]);

export const DEEPFAKE_MODE_OPTIONS = optionsProxy.create([
  { value: 1, get label() { return i18n.t('constants:deepfake.mode.swap'); } },
  { value: 2, get label() { return i18n.t('constants:deepfake.mode.swap+synt'); } },
]);

export const META_TYPE = optionsProxy.create([
  { value: 'string', get label() { return i18n.t('constants:meta type.string'); } },
  { value: 'integer', get label() { return i18n.t('constants:meta type.integer'); } },
  { value: 'numeric', get label() { return i18n.t('constants:meta type.numeric'); } },
]);

export const META_NUM_OPERATOR = optionsProxy.create([
  { value: 'eq', get label() { return 'eq'; } },
  { value: 'neq', get label() { return 'neq'; } },
  { value: 'in', get label() { return 'in'; } },
  { value: 'nin', get label() { return 'nin'; } },
  { value: 'gt', get label() { return 'gt'; } },
  { value: 'gte', get label() { return 'gte'; } },
  { value: 'lt', get label() { return 'lt'; } },
  { value: 'lte', get label() { return 'lte'; } },
]);

export const META_STR_OPERATOR = optionsProxy.create([
  ...META_NUM_OPERATOR.raw,
  { value: 'like', get label() { return 'like'; } },
  { value: 'nlike', get label() { return 'nlike'; } },
]);

export const STREAM_DATA_TYPE_OPTIONS = optionsProxy.create([
  { value: 'videofile', get label() { return i18n.t('constants:stream data type.videofile'); } },
  { value: 'stream', get label() { return i18n.t('constants:stream data type.stream'); } },
]);

export const TIMESTAMP_SOURCE_OPTIONS = optionsProxy.create([
  { value: 'auto', get label() { return i18n.t('constants:timestamp source.auto'); } },
  { value: 'pts', get label() { return i18n.t('constants:timestamp source.pts'); } },
  { value: 'server', get label() { return i18n.t('constants:timestamp source.server'); } },
  { value: 'frame_rate', get label() { return i18n.t('constants:timestamp source.frames'); } },
]);

export const TIME_FILTER_TYPE_OPTIONS = optionsProxy.create([
  { value: 'median', get label() { return i18n.t('constants:time filter type.median'); } },
  { value: 'min', get label() { return i18n.t('constants:time filter type.min'); } },
]);

export const NOTIFICATION_TYPE_OPTIONS = optionsProxy.create([
  { value: 'videoanalytics', get label() { return i18n.t('constants:notifications.type.videoanalytics'); } },
  { value: 'events', get label() { return i18n.t('constants:notifications.type.events'); } },
]);
